import { Col, Row } from "react-bootstrap";

interface IInverterInfo {
  title: string;
  value: string | React.ReactNode;
}

interface IProps {
  inverterInfo: IInverterInfo[];
}

const VrmInverterInformation = (props: IProps) => {
  return (
    <Row>
      {props.inverterInfo.map((i, index) => {
        return (
          <Col className="col-12 col-sm-6">
            <Row key={index} className="my-2">
              <Col className="font-weight-400 font-size-14 text-light col-auto pe-0">
                {i.title}:
              </Col>
              <Col className="font-weight-400 font-size-14 text-dark">
                {i.value}
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
};

export default VrmInverterInformation;
